// extracted by mini-css-extract-plugin
export default {"mainBox":"main_mainBox__mWfkf"};